import { InputGroup } from '@/features/_components/input-group'
import { SkeletonField } from './skeleton-field'

interface SkeletonInputGroupProps {
  fields: number
  fieldClassName?: string
}

export const SkeletonInputGroup = ({ fields, fieldClassName }: SkeletonInputGroupProps) => {
  return (
    <InputGroup>
      {Array.from({ length: fields }).map((_, i) => (
        <SkeletonField key={i} className={fieldClassName} />
      ))}
    </InputGroup>
  )
}
